import axios, { AxiosHeaders, InternalAxiosRequestConfig } from 'axios'
import { AuthenticationClient } from '../../features/authentication/slice/authenticationSlice'

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || '',
  withCredentials: true,
})

instance.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = localStorage.getItem('access_token')
    ? `Bearer ${localStorage.getItem('access_token')}`
    : ''

  const prescriberStr = localStorage.getItem('prescriber')
  const prescriberId =
    prescriberStr !== 'undefined' && prescriberStr?.length ? JSON.parse(prescriberStr).id : ''

  const headers = AxiosHeaders.from(config.headers)
  headers.set('Authorization', token)
  headers.set('Prescriber-Id', prescriberId)
  headers.set('Id-Token', localStorage.getItem('id_token') || '')
  config.headers = headers

  return config
})

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    const clientId = localStorage.getItem('client_id')
    const refreshToken = localStorage.getItem('refresh_token')
    if (error?.response?.status === 401 && clientId && refreshToken) {
      const { data } = await AuthenticationClient.refreshAccessToken({
        clientId,
        refreshToken,
      })
      if (data && data.assessToken) {
        localStorage.setItem('access_token', data.assessToken)
        const { config } = error
        const headers = AxiosHeaders.from(config.headers)
        headers.set('Authorization', 'Bearer ' + data.assessToken)
        config.headers = headers
        return axios(config)
      } else {
        return Promise.reject(error)
      }
    }
    return Promise.reject(error)
  }
)

export default instance
